
const ScrollbarStyle = `
    ::-webkit-scrollbar {
        height: 5px;
        width: 5px;
    }
    
    ::-webkit-scrollbar-track {
        background: transparent;
    }
    
    ::-webkit-scrollbar-thumb {
        background: #d6dadc;
        border-radius: 4px;
    }
    
    ::-webkit-scrollbar-thumb:hover {
        background: #d6dadc;
 }
 `;


export default ScrollbarStyle;
